import { checkArray } from "./checkArray";
import { get } from "../utils/helpers";
import { PAYMENT_INFO } from "constants/index";
import { IcustomerVpaList, INetBankingDetails, IOffersData, IsavedCardDTOList, paymentInfoInterface, PaymentOfferRule } from "@nykaa/payment-sdk/src/Payment/@types";
import { OfferDataInterface } from "./@types";


export const doCheckOffers = (
  isSaved: boolean,
  paymentMethod: string | undefined,
  cartRules?: IOffersData,
  paymentInfo?: paymentInfoInterface,
  validatedOffers?: string[],
) => {
  const customerType: number | undefined = get(cartRules, "customerType");

  // no offers applied in case of cashFree seamless and wallet multimodal case
  if (!cartRules) {
    return {
      hasOffers: false,
      offers: [],
      finalOrderAmount: null,
      customerType,
    };
  }
  const paymentRules = (cartRules && cartRules.paymentRules) || [];
  const offersData = getOfferKeyWithValues(paymentRules);
  let offers: OfferDataInterface[] = [];
  let offer: OfferDataInterface | undefined = { finalOrderAmount: 0 };
  if (isSaved) {
    const zest = get(paymentInfo, "zest");
    const savedCardDTOList = get(paymentInfo, "savedCardDTOList");
    const netBankingList = get(paymentInfo, "netBankingList");
    const customerVpaList = get(paymentInfo, "customerVpaList");
    const simplDTO = get(paymentInfo, "simplDTO");
    const paytmUserDTO = get(paymentInfo, "paytmUserDTO");

    for (let paymentInfoKey in paymentInfo) {
      // check zest_money offer key is present or not
      if (paymentInfoKey === PAYMENT_INFO.ZEST && checkArray(zest?.offerKeys)) {
        offers.push(offersData[zest.offerKeys[0]]);
      }
      // check saved card offer key is present or not
      if (
        paymentInfoKey === PAYMENT_INFO.CARD &&
        checkArray(savedCardDTOList) &&
        savedCardDTOList?.findIndex((list: IsavedCardDTOList) => list.offerKeys?.length) !== -1
      ) {
        savedCardDTOList?.forEach((cardList: IsavedCardDTOList) => {
          if (checkArray(cardList.offerKeys)) {
            offers.push(offersData[cardList.offerKeys[0]]);
          }
        });
      }
      // check net banking offer key is present or not
      if (
        paymentInfoKey === PAYMENT_INFO.NB &&
        checkArray(netBankingList) &&
        netBankingList?.findIndex((list: INetBankingDetails) => list.offerKeys?.length) !== -1
      ) {
        netBankingList?.forEach((nbList: INetBankingDetails) => {
          if (checkArray(nbList.offerKeys) && nbList.offerKeys) {
            offers.push(offersData[nbList.offerKeys[0]]);
          }
        });
      }
      // check upi offer key is present or not
      if (
        paymentInfoKey === PAYMENT_INFO.UPI &&
        checkArray(customerVpaList) &&
        customerVpaList?.findIndex((list: IcustomerVpaList) => list.offerKeys?.length) !== -1
      ) {
        customerVpaList?.forEach((vpaList: IcustomerVpaList) => {
          if (checkArray(vpaList.offerKeys)) {
            offers.push(offersData[vpaList.offerKeys[0]]);
          }
        });
      }
      // check simpl offer key is present or not
      if (
        paymentInfoKey === PAYMENT_INFO.SIMPL &&
        checkArray(simplDTO?.offerKeys) && simplDTO?.offerKeys
      ) {
        offers.push(offersData[simplDTO.offerKeys[0]]);
      }
      // check paytm offer key is present or not
      if (
        paymentInfoKey === PAYMENT_INFO.PAYTM &&
        checkArray(paytmUserDTO?.offerKeys) && paytmUserDTO?.offerKeys
      ) {
        offers.push(offersData[paytmUserDTO.offerKeys[0]]);
      }
    }

    // offer = find(offers, { paymentMethod });
    offer = offers?.find((data:any) => data?.paymentMethod === paymentMethod);
  } else {
    validatedOffers?.map((offerKey: string) =>
      offers.push(offersData[offerKey])
    );
    // offer = find(offers, { paymentMethod });
    offer = offers?.find((data:any) => data?.paymentMethod === paymentMethod);
  }
  return transformOfferData(offer, customerType);
};

const getOfferKeyWithValues = (paymentRules: PaymentOfferRule[]) => {
  let offersData: { [key: string]: PaymentOfferRule } = {};
  paymentRules.forEach((paymentRule: PaymentOfferRule) => {
    if (!offersData[paymentRule.ruleKey as string]) {
      offersData[paymentRule.ruleKey as string] = paymentRule;
    }
  });
  return offersData;
};

const transformOfferData = (offer: OfferDataInterface | undefined, customerType: number| undefined) => {
  if (offer) {
    return {
      hasOffers: true,
      offers: (offer.extraCartRuleParams && offer.extraCartRuleParams.tags) || [],
      finalOrderAmount: offer.finalOrderAmount,
      discountAmount: offer.discountAmount,
      discountPercent: offer.discountPercent,
      customerType,
      ruleKey: offer.ruleKey || "",
      validTillDate: offer.validTillDate || "",
      usagePerCustomer: offer.usagePerCustomer,
      cashbackAmount: offer.cashbackAmount,
      deltaAmount: offer.deltaAmount,
      paymentMethodMessage: offer.paymentMethodMessage,
      fixedDiscount: offer.fixedDiscount,
      maximumDiscount: offer.maximumDiscount,
      minPayableAmount: offer.minPayableAmount,
      offerLongDescription: offer.offerLongDescription,
      offerTNC: offer.offerTNC,
      orderAmount: offer.orderAmount,
      paymentMethod: offer.paymentMethod,
      priority: offer.priority,
      termsAndConditionsLink: offer.termsAndConditionsLink,
      discountAmountMsg: offer.discountAmountMsg,
      description: offer.description,
      discountType: offer.discountType,
      name: offer.name,
      ruleId: offer.ruleId,
      type: offer.type,
      deltaAmountMsg: offer.deltaAmountMsg,
      offerImageUrl: offer.offerImageUrl,
      genericDiscountMsg: offer.genericDiscountMsg,
    };
  }
  return {
    hasOffers: false,
    offers: [],
    finalOrderAmount: null,
    discountPercent: null,
    customerType,
  };
};

export const getSavedOffer = (paymentInfo: paymentInfoInterface, cartRules: IOffersData) => {
  const offersData = getOfferKeyWithValues(cartRules?.paymentRules);
  let offers: OfferDataInterface[] = [];

  const savedCardDTOList = get(paymentInfo, "savedCardDTOList");
  const netBankingList = get(paymentInfo, "netBankingList");
  const customerVpaList = get(paymentInfo, "customerVpaList");
  const simplDTO = get(paymentInfo, "simplDTO");
  // const paytmUserDTO = get(paymentInfo, 'paytmUserDTO');

  for (let paymentInfoKey in paymentInfo) {
    if (
      paymentInfoKey === PAYMENT_INFO.CARD &&
      checkArray(savedCardDTOList) &&
      savedCardDTOList.findIndex((list: IsavedCardDTOList) => list.offerKeys?.length) !== -1
    ) {
      savedCardDTOList.forEach((cardList: IsavedCardDTOList) => {
        /**
         * Getting the offerData respective to sorted rule id and add it to offers array.
         */
        if (checkArray(cardList.offerKeys) && cardList?.offerKeys?.length && offersData[cardList.offerKeys[0]]) {
          offers.push(offersData[cardList.offerKeys[0]]);
        }
      });
    }
    if (
      paymentInfoKey === PAYMENT_INFO.NB &&
      checkArray(netBankingList) &&
      netBankingList.findIndex((list: INetBankingDetails) => list.offerKeys?.length) !== -1
    ) {
      netBankingList.forEach((nbList: INetBankingDetails) => {
        /**
         * Getting the offerData respective to sorted rule id and add it to offers array.
         */
        if (checkArray(nbList.offerKeys) && nbList?.offerKeys?.length && offersData[nbList.offerKeys[0]]) {
          offers.push(offersData[nbList.offerKeys[0]]);
        }
      });
    }
    if (
      paymentInfoKey === PAYMENT_INFO.UPI &&
      checkArray(customerVpaList) &&
      customerVpaList.findIndex((list: IcustomerVpaList) => list.offerKeys?.length) !== -1
    ) {
      customerVpaList.forEach((vpaList: IcustomerVpaList) => {
        if (checkArray(vpaList.offerKeys) && vpaList?.offerKeys?.length && offersData[vpaList.offerKeys[0]]) {
          offers.push(offersData[vpaList.offerKeys[0]]);
        }
      });
    }
    if (
      paymentInfoKey === PAYMENT_INFO.SIMPL &&
      checkArray(simplDTO?.offerKeys) && simplDTO.offerKeys.length && offersData[simplDTO.offerKeys[0]]
    ) {
      offers.push(offersData[simplDTO.offerKeys[0]]);
    }
    // if (
    //   paymentInfoKey === PAYMENT_INFO.PAYTM &&
    //   checkArray(paytmUserDTO?.offerKeys)
    // ) {
    //   offers.push(offersData[paytmUserDTO.offerKeys[0]]);
    // }
  }
  return offers;
};
